<template>
    <el-dialog :visible.sync="addExpressInformation" width="767px" :title="title" class="addBrand" @close='close'>
      <el-form :model="queryParams" ref="queryParamsRefs" :rules="queryParamsRules" label-width="100px">
        <el-row :gutter="2">
          <el-col :span="12">
            <el-form-item  prop="storageName" label="仓库名称：">
              <el-input v-model.trim="queryParams.storageName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
            <el-col :span="16">
              <el-form-item label="所在地区：" :rules="filter_rules({required:true, type:'change'})">
                <el-Address
                :provinceEdit="provinceManage"
                :city="cityManage"
                :district="districtManage"
                @changAddress='changAddressManage'></el-Address>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item  label="详细地址：" prop="storageAddress">
              <el-input v-model.trim="queryParams.storageAddress" placeholder="输入详细地址" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
             <el-form-item label="联系人：" prop='storageAdmin'>
                <el-input v-model.trim="queryParams.storageAdmin" placeholder="输入联系人" ></el-input>
             </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：" prop="storagePhone">
              <el-input v-model.trim="queryParams.storagePhone" placeholder="输入联系方式"   oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input v-model="queryParams.mark" rows="6" type="textarea" placeholder="请填写备注" :disabled="forbidden"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="onClose('queryParamsRefs')">取 消</el-button>
      </span>

    </el-dialog>
</template>

<script>
import { addStorageBasesVo } from '@/api/storage/storage'
import Address from '@/components/Address/index'
import { addOrEditBrandRules } from '../util/formRules'
export default {
  components: {
    'el-Address': Address
  },
  data () {
    return {
      banne: false,
      forbidden: false,
      addExpressInformation: false,
      queryParams: {},
      provinceManage: {}, // 经营省
      cityManage: {}, // 经营市
      districtManage: {}, // 经营区/县
      type: 0, // 0 新增 1修改
      title: '',
      queryParamsRules: {} // 校验
    }
  },
  methods: {
    // 新增物流信息
    onInitialize (type, row) { // 0 新增 1修改
      this.forbidden = false
      this.queryParams = {}
      this.provinceManage = {} // 经营省
      this.cityManage = {}// 经营市
      this.districtManage = {} // 经营区/县
      this.queryParamsRules = addOrEditBrandRules// 初始化校验
      this.type = type
      this.title = '仓库信息'
      this.addExpressInformation = true
    },
    // 选择修改地址
    changAddressManage (params) {
      this.queryParams.province = params.name
      this.queryParams.procode = params.code
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) { // 校验通过
          if (!this.queryParams.province) {
            this.$message.error('请选择所在地区')
          } else {
            addStorageBasesVo(this.queryParams).then(res => {
              if (res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.addExpressInformation = false
                this.$emit('updateStorage', this.queryParams)
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              console.log(err)
            })
          }
        }
      })
    },
    // 点击详情显示修改对话框
    edit () {
      this.forbidden = false
      this.banne = true
    },
    // 取消关闭弹窗
    onClose () {
      this.addExpressInformation = false
      this.forbidden = true
      this.banne = false
      this.$refs.queryParamsRefs.clearValidate()// 去掉校验
    },
    close () {
      this.queryParams.province = ''
      this.$refs.queryParamsRefs.clearValidate()// 去掉校验
    }
  }
}
</script>

<style>

</style>
